import { FormattedNumber } from 'i18n'
import { currencyFromSymbol } from 'shared/currency-utilities'
import EditBookingPriceBreakdown from 'shared/components/EditBookingPriceBreakdown'

import './styles.scss'

const PriceBreakdown = ({
    rateTable,
    itemTotal,
    total,
    promoCode,
    currencySymbol,
    isMultipleBooking,
    additionalServices,
    additionalServicePrice,
    editedReservationNewTotalPrice,
    newPrice,
    oldPrice,
    amendmentFee,
    rate,
    showPriceDifference,
}) => {
    const currency = currencyFromSymbol(currencySymbol)
    const totalPrice = additionalServicePrice()
        ? additionalServicePrice() + (isMultipleBooking ? itemTotal : total)
        : isMultipleBooking
          ? itemTotal
          : total

    return (
        <div className="price-summary">
            {rateTable &&
                rateTable.map((rateRow, index) => (
                    <div key={index} className="d-flex justify-content-between my-2">
                        <span className="mr-2">{rateRow.rateName}</span>
                        <FormattedNumber value={rateRow.amount} style="currency" currency={currency} />
                    </div>
                ))}
            {promoCode != null && (
                <div className="d-flex justify-content-between my-2 price-summary__discount">
                    <span>{promoCode.barcode}</span>
                    <FormattedNumber value={-promoCode.promoDiscount} style="currency" currency={currency} />
                </div>
            )}
            {additionalServices &&
                additionalServices.map((item, index) => (
                    <div key={index} className="d-flex justify-content-between my-2 ">
                        <span>{item.feeName}</span>
                        <FormattedNumber value={item.value} style="currency" currency={currency} />
                    </div>
                ))}
            {!isMultipleBooking && <hr className="price-summary__break" />}
            <div
                className={`d-flex justify-content-between my-2 ${
                    isMultipleBooking ? 'font-weight-bold' : 'is-single'
                } ${showPriceDifference && 'flex-column'}`}>
                {showPriceDifference ? (
                    <EditBookingPriceBreakdown
                        editedReservationNewTotalPrice={editedReservationNewTotalPrice}
                        newPrice={newPrice}
                        oldPrice={oldPrice}
                        amendmentFee={amendmentFee}
                        rate={rate}
                        rateCurrencySymbol={currencySymbol}
                        isModal
                    />
                ) : (
                    <>
                        <T>{isMultipleBooking ? 'basket.total.label' : 'basket.total.to.pay.label'}</T>
                        <span className={`${isMultipleBooking ? '' : 'price-summary__price'}`}>
                            <FormattedNumber value={totalPrice} style="currency" currency={currency} />
                        </span>
                    </>
                )}
            </div>
        </div>
    )
}

PriceBreakdown.propTypes = {
    rateTable: PropTypes.arrayOf(
        PropTypes.shape({
            rateName: PropTypes.string,
            amount: PropTypes.number,
        })
    ),
    itemTotal: PropTypes.number,
    total: PropTypes.number,
    promoCode: PropTypes.shape({}),
    currencySymbol: PropTypes.string,
    isSingleBooking: PropTypes.bool,
}

export default PriceBreakdown
